export const VIDEO_IN_APP_VALIDATION_ENABLED_BUTTON_TEXT = 'Record a video';

export const THREAD_RESTRICTED_TEXT = 'This prospect has restricted incoming communication.';
